import BudgetSummary from "components/main/BudgetSummary";
import Column from "../components/Column";
import ExhaustionEstimation from "components/payment/ExhaustionEstimation";
import PaymentHistory from "components/payment/PaymentHistory";
import React from "react";
import Row from "../components/Row";
import { compose } from "redux";
import paymentSelectors from "modules/payment/selectors";
import { useSelector } from "react-redux";
import withUserPerm from "services/withUserPerm";

const Payment = () => {
  const remainingBudgetList = useSelector((state) => paymentSelectors.remainingBudgetList(state));
  const avgUsage = useSelector((state) => paymentSelectors.avgUsage(state));
  const daysToExhaust = parseInt(remainingBudgetList.remainingBudget / avgUsage) || "0";

  return (
    <div>
      <BudgetSummary />
      <Row columnSpacing="8px" responsive>
        <>
          {remainingBudgetList.creditCard ? (
            <>
              <Column>
                <PaymentHistory />
              </Column>
              <Column />
            </>
          ) : (
            <>
              <Column>
                <ExhaustionEstimation
                  avgUsage={avgUsage}
                  remainingBudgetList={remainingBudgetList.list}
                  daysToExhaust={daysToExhaust}
                />
              </Column>
              <Column>
                <PaymentHistory />
              </Column>
            </>
          )}
        </>
      </Row>
    </div>
  );
};

export default compose(withUserPerm())(Payment);
